import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";


export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCollectionWard: builder.query({
            query: ({ page, filterData }) => {
                let query = `b2g/eco-admin/collection-ward-date`;

                const queryArr = [];

                // Always include the page number
                queryArr.push(`page=${page}`);
                // console.log(filterData, filterData?.ward_id, filterData?.start_date, filterData?.end_date);

                // Conditionally include filters if they exist
                if (filterData?.ward_id) {
                    queryArr.push(`ward_id=${filterData.ward_id}`);
                }
                if (filterData?.startdate) {
                    queryArr.push(`start_date=${filterData.startdate}`);
                }
                if (filterData?.enddate) {
                    queryArr.push(`end_date=${filterData.enddate}`);
                }

                // Combine base URL with query parameters
                query += '?' + queryArr.join('&');
                return query;
            },

            transformResponse: responseData => {
                return responseData?.data;
            },
            providesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        getCollectionWard_Data: builder.query({
            query: ({ time, ward }) => `b2g/eco-admin//collection-details-ward-date?ward_id=${ward}&collection_date=${time}`,
            // query: ({ time, ward }) => `b2g/eco-admin//collection-details-ward-date?ward_id=a0f5&collection_date=${time}`,
            transformResponse: responseData => {
                return responseData?.data;
            },
            providesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        // addNewcleanerapp: builder.mutation({
        //     query: body => ({
        //         url: '/b2g/eco-admin/cleaner',
        //         method: 'POST',
        //         body: body
        //     }),
        //     invalidatesTags: [
        //         { type: 'B2gUserApp', id: 'List' }
        //     ]
        // }),
        // deleteCleanerApp: builder.mutation({
        //     query: id => ({
        //         url: `/b2g/eco-admin/cleaner/${id}`,
        //         method: 'DELETE',
        //     }),
        //     invalidatesTags: [
        //         { type: 'B2gUserApp', id: 'List' }
        //     ]
        // }),
        // editcleanerApp: builder.mutation({
        //     query: payLoad => ({
        //         url: `/b2g/eco-admin/cleaner`,
        //         method: 'PATCH',
        //         body: payLoad
        //     }),
        //     invalidatesTags: [
        //         { type: 'B2gUserApp', id: 'List' }
        //     ]
        // }),
    })
})

export const {
    useGetCollectionWardQuery,
    useGetCollectionWard_DataQuery,
    // useAddNewcleanerappMutation,
    // useDeleteCleanerAppMutation,
    // useEditcleanerAppMutation,
} = extendedApiSlice
